import React from "react";
import {Container,ConFacturas} from "./styles";


export function MainCont({children,plantilla}) {

    const Plantillas = {
        3: process.env.REACT_APP_URL_MULTIMEDIA_EPAYCO + "/dashboard/recaudo/proyecto/imagenes/plantilla_1.png",
        2: process.env.REACT_APP_URL_MULTIMEDIA_EPAYCO + "/dashboard/recaudo/proyecto/imagenes/plantilla_2.png",
        1: process.env.REACT_APP_URL_MULTIMEDIA_EPAYCO + "/dashboard/recaudo/proyecto/imagenes/plantilla_3.png",
        4: process.env.REACT_APP_URL_MULTIMEDIA_EPAYCO + "/dashboard/recaudo/proyecto/imagenes/plantilla_4.png",
    };

    return (
        <Container plantilla={Plantillas[plantilla]}>
            {children}
        </Container>
    )
}

export default React.memo(MainCont);

export const FacturaContainer = ({children})=>{
    return (
        <ConFacturas>
            {children}
        </ConFacturas>
    )
};

